import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { postApiData } from "../helpers/AxiosInstance";
interface IUsePostHook {
  queryKey: string[];
}
const useNoticePostHook = (props: IUsePostHook) => {
  const { queryKey } = props;
  const queryClient = useQueryClient();

  const {
    isPending: isPostLoading,
    mutateAsync,
    isSuccess: isPostSuccess,
    data: postData,
    isError: isPostError,
  } = useMutation({
    mutationFn: postApiData,
    onSuccess: async (data) => {
      if (data?.status === 201 || data?.status === 200) {
        console.log(data?.data?.message);
      } else {
        if (data?.data?.non_field_errors) {
          console.log(data?.data?.message);
        } else {
          console.log(data?.data?.message);
        }
      }
    },
    onError: (error) => {
      toast.error("Error");
    },

    onSettled: async () => {
      queryClient.invalidateQueries({
        queryKey: queryKey,
        refetchType: "active",
      });
    },
  });
  return {
    isPostLoading,
    mutateAsync,
    isPostSuccess,
    postData,
    isPostError,
  };
};

export default useNoticePostHook;
